@if (message) {
  <p [class]="severity" class="alert" role="alert">{{ message }}</p>
} @else {
  <p>&nbsp;</p>
}
